import React from 'react';
import { FaStar, FaRegHeart, FaShare, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
import { TiShoppingCart } from "react-icons/ti";
import { useNavigate } from 'react-router-dom';
import hotToast from 'react-hot-toast';
import { useAddToCartMutation, useFetchCartQuery } from '../../features/cartSlice';
import { useFetchFavoritesQuery, useToggleFavoritesMutation } from '../../features/favoritesSlice';
import Cookies from 'js-cookie';


const ProductInfo = ({product}) => {

  const productId = product?._id || product?.id;

  const navigate = useNavigate();

  const { data: cartData } = useFetchCartQuery();
  const cartItems = cartData?.data?.inCartProducts || [];

  const [addToCart] = useAddToCartMutation();

  const { data: favoritesData } = useFetchFavoritesQuery();
  const favItems = favoritesData?.data?.favoriteProducts || [];

  const [toggleFavorites] = useToggleFavoritesMutation();

  const inCart = cartItems.some((cartItem) => (cartItem.product?._id || cartItem.product?.id) === productId);
  const inFav = favItems.some((favItem) => (favItem._id || favItem.id) === productId); 

  const isAuthenticated = Cookies.get('accessToken') ? true : false;

  const renderStars = () => {
    if (!product?.rating && product?.rating !== 0) return null;

    const stars = [];
    const fullStars = Math.floor(product.rating);
    const hasHalfStar = product.rating % 1 !== 0;
    const totalStars = 5;
    
    // full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`}/>);
    }

    // has half star
    if(hasHalfStar) {
      stars.push(<FaStarHalfAlt key='half'/>);
    }

    // empty stars
    const remaining = totalStars - stars.length;
    for (let i = 0; i < remaining; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }

    return stars;
  }

  const handleAddToCart = () => {
    if(!isAuthenticated) {
      hotToast.error('Please login first');
      return;
    }
    if(!product || inCart) return;
    addToCart({ productId, product }).unwrap().then(() => {
      hotToast.success(
        <div className='toast-wrapper'>
          <img src={product.images[0]} alt="toast-img" />
          <div className="toast-contet">
            <strong>{product.title}</strong>
            Added To Cart
            <button className='btn' onClick={() => navigate('/cart')}>View Cart</button>
          </div>
        </div>
        ,{duration: 3500}
      )
    }).catch((error) => {
      hotToast.error('Error addToCart: ' + error);
    })
  }

  const handleAddToFav = () => {
    if(!isAuthenticated) {
      hotToast.error('Please login first');
      return;
    }
    if (!product) return;
    toggleFavorites({ productId, product: product }).unwrap().then(() => {
      inFav 
      ? hotToast.error(
        <div className='toast-wrapper'>
          <img src={product.images[0]} alt="toast-img" />
          <div className="toast-contet">
            <strong>{product.title}</strong>
            Removed From Favorites
          </div>
        </div>
        ,{duration: 3500}
      ) 
      : hotToast.success(
        <div className='toast-wrapper'>
          <img src={product.images[0]} alt="toast-img" />
          <div className="toast-contet">
            <strong>{product.title}</strong>
            Added To Favorites
          </div>
        </div>
        ,{duration: 3500}
      )
    }).catch((error) => {
      hotToast.error('Error toggleFavorites: ' + error);
    })
  }

  return ( 
    <div className="product-info">
      <h1>{product.title}</h1>
      <div className="rating">
        {renderStars ()}
      </div>
      <p className="price">$ {product.price}</p>
      <h5>Availability: <span>{product.availabilityStatus}</span></h5>
      <h5>Brand: <span>{product.brand}</span></h5>
      <p className='desc'>{product.description}</p>
      <h5 className='stock'><span>Only {product.stock} products left in Stock</span></h5>
      <button 
        className={`btn ${ inCart ? 'in-cart-btn' : '' }`} 
        onClick={() => inCart ? navigate('/cart') : handleAddToCart()}
      >
        { inCart ? 'View Cart' : 'Add to Cart'} 
        <TiShoppingCart />
      </button>
      <div className="icons">
        <span className={ inFav ? 'in-fav' : '' } onClick={handleAddToFav}><FaRegHeart /></span>
        <span><FaShare /></span>
      </div>
    </div>
  );
}

export default ProductInfo;